import { useEffect } from "react";
import useCheckoutStore from "src/store/checkout.store";
import { useDeliveryCouponQuery } from "../queries/useCouponQuery";
// 배송비 쿠폰 조회 및 적용 커스텀 훅
const useDeliveryCoupon = (param)=>{
    let { isLoggedIn , orderType  } = param;
    const { applyDeliveryCoupon , removeDeliveryCoupon , deliveryFeeCouponId  } = useCheckoutStore((state)=>({
            applyDeliveryCoupon: state.applyDeliveryCoupon,
            removeDeliveryCoupon: state.removeDeliveryCoupon,
            deliveryFeeCouponId: state.deliveryInfo.deliveryFeeCouponId
        }));
    const couponType = orderType === "pod" ? "pod" : orderType === "delivery" ? "handout" : null;
    const { data: deliveryCoupons  } = useDeliveryCouponQuery({
        enabled: isLoggedIn && couponType !== null,
        type: couponType
    });
    const handleChangeDeliveryFeeCoupon = (id)=>{
        var _deliveryCoupons_coupons_find;
        var _deliveryCoupons_coupons_find_discountValue;
        const getDeliveryFeeCouponAmount = (_deliveryCoupons_coupons_find_discountValue = (_deliveryCoupons_coupons_find = deliveryCoupons === null || deliveryCoupons === void 0 ? void 0 : deliveryCoupons.coupons.find((coupon)=>coupon.id === id)) === null || _deliveryCoupons_coupons_find === void 0 ? void 0 : _deliveryCoupons_coupons_find.discountValue) !== null && _deliveryCoupons_coupons_find_discountValue !== void 0 ? _deliveryCoupons_coupons_find_discountValue : 0;
        applyDeliveryCoupon(id, getDeliveryFeeCouponAmount);
    };
    // 초기 배송비 쿠폰 적용 (쿠폰이 있고 현재 적용된 쿠폰이 없을 때)
    useEffect(()=>{
        if ((deliveryCoupons === null || deliveryCoupons === void 0 ? void 0 : deliveryCoupons.coupons.length) > 0) {
            var _deliveryCoupons_coupons__discountValue;
            const couponAmount = (_deliveryCoupons_coupons__discountValue = deliveryCoupons === null || deliveryCoupons === void 0 ? void 0 : deliveryCoupons.coupons[0].discountValue) !== null && _deliveryCoupons_coupons__discountValue !== void 0 ? _deliveryCoupons_coupons__discountValue : 0;
            applyDeliveryCoupon(deliveryCoupons === null || deliveryCoupons === void 0 ? void 0 : deliveryCoupons.coupons[0].id, couponAmount);
        }
        if ((deliveryCoupons === null || deliveryCoupons === void 0 ? void 0 : deliveryCoupons.coupons.length) === 0) {
            removeDeliveryCoupon();
        }
    }, [
        deliveryCoupons
    ]);
    return {
        deliveryCoupons,
        handleChangeDeliveryFeeCoupon
    };
};
export default useDeliveryCoupon;
